module.exports = __webpack_public_path__ + "img/boy-head-front.d87e78d4.png";